module.exports = __webpack_public_path__ + "static/media/dogImage2.7e0b941d.jpg";